import React from "react";

const TowerRightArea = () => {
  return (
    <div className="tower-right-area">
      <div className="side-instructions-wrapper">
        <h4 className="side-instructions-head">Instructions</h4>

        <div className="side-instructions-para">
          <p>
            <strong>1:</strong> Click items from top to build tower.
          </p>
          <p>
            <strong>2:</strong> Select only healthy items.
          </p>
          <p>
            <strong>3:</strong> An Unhealthy item selected can collapse the
            tower.
          </p>
          <p>
            <strong>4:</strong> Make 5 storey tower for next level.
          </p>
          <p>
            <strong>5:</strong> Complete 3 levels to win the game.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TowerRightArea;
